import rpAPI from '../service/rpAPI.js';
import Globals from './Globals.js';
import Group from './Group.js';
import Instructor from './Instructor.js';
import Location from './Location.js';
import Tag from './Tag.js';


// ReservePro Reservation Model
export default class GroupReservation {
  static fields = [
    '*',
    'contract.*',
    'payment.id',
    'payment.name',
    'payment.company',
    'payment.nip',
    'payment.address',
    'payment.city',
    'payment.postcode',
    'payment.description',
    'payment.method',
    'payment.payment_link',
    'payment.bank_account',
    'agreements.Agreements_id.*',

    ...Instructor.fields.map(field => `groups.ClassOffer_id.instructor.${field}`),

    'groups.ClassOffer_id.*',
    'groups.ClassOffer_id.contract.*',
    'groups.ClassOffer_id.location.*',
    'groups.ClassOffer_id.payment.id',
    'groups.ClassOffer_id.payment.name',
    'groups.ClassOffer_id.payment.company',
    'groups.ClassOffer_id.payment.nip',
    'groups.ClassOffer_id.payment.address',
    'groups.ClassOffer_id.payment.city',
    'groups.ClassOffer_id.payment.postcode',
    'groups.ClassOffer_id.payment.description',
    'groups.ClassOffer_id.payment.method',
    'groups.ClassOffer_id.payment.payment_link',
    'groups.ClassOffer_id.payment.bank_account',
    'groups.ClassOffer_id.level.tags_id.*',
    'groups.ClassOffer_id.early_birds.related_ClassOffer_id.id',
    'agreements.Agreements_id.*',

    ...Instructor.fields.map(field => `groups.ClassOffer_id.instructor.${field}`),
    ...Location.fields.map(field => `groups.ClassOffer_id.location.${field}`),

    'groups.ClassOffer_id.*',
    'groups.ClassOffer_id.contract.*',

    'groups.ClassOffer_id.level.tags_id.*',
    'groups.ClassOffer_id.condition.tags_id.*',
    'groups.ClassOffer_id.age.tags_id.*',
    'groups.ClassOffer_id.dance.tags_id.*',
    'groups.ClassOffer_id.agreements.Agreements_id.*',
    'groups.ClassOffer_id.class_hours.ClassHours_id.*',

    ...Location.fields.map(field => `groups.ClassOffer_id.class_hours.ClassHours_id.location.${field}`),
    ...Instructor.fields.map(field => `groups.ClassOffer_id.class_hours.ClassHours_id.instructor.${field}`),

  ];

  constructor(data) {
    // copy all data to this
    Object.assign(this, data);

    this.image = rpAPI.getAssetUrl(this.thumb, '?quality=80&format=webp');

    this.description = GroupReservation.parseDescription(data.description?.blocks);
    this.shorten = this.description[0]?.content || '';
    this.long = this.description?.map(item => item.title + item.content).join('') || '';
    this.groups = data.groups?.map(g => new Group(g['ClassOffer_id'])) || [];

    this.tags = data.tags?.map(t => new Tag({'title': t})) || [];
    this.tagList = data.tags?.map(t => t.title || t).join(', ') || '';
    const reservationSlug = data.link || '';
    
    this.link = Globals.APP_URL + '/' + reservationSlug;  

    // for each group copy the title and description
    let reservvationImage = this.image;
    let reservationTitle = this.name || '';
    let reservationDescription = data.description || '';
    let reservationLink = this.link;
    let reservationWebsite = this.website_url || null;
    let reservationBasePrice = this.price_base || 0;
    let reservationDiscountInfo = this.price_discount_info || '';
    let reservationCurrency = this.currency || '';

    let reservationContractTemplate = data.contract;
    let reservationPayment = data.payment;
    this.contract = reservationContractTemplate;

    let reservationAgreements = data.agreements?.map(a => ({
      id: a['Agreements_id'].id,
      title: a['Agreements_id'].title,
      required: a['Agreements_id'].required,
      condition: a['Agreements_id'].condition,
      content: a['Agreements_id'].content,
      acceptance: a['Agreements_id'].acceptance,
      document_url: a['Agreements_id'].document_url,
      sort: a['Agreements_id'].sort || 0,
    })) || [];

    this.groups.forEach(group => {

      // check if image 
      if (!group.image) {
        group.image = reservvationImage;
      }

      if (!group.contract) {
        group.contract = reservationContractTemplate;
      } 

      if (!group.payment) {
        group.payment = reservationPayment;
      }

      group.description = GroupReservation.parseDescription(group.description?.blocks)?.map(item => (item?.title || '') + item?.content || '').join('') || '';
      
      group.reservationTitle = reservationTitle;
      group.reservationSlug = reservationSlug;
      group.website = group.website_url || reservationWebsite;
      group.reservationDescription = reservationDescription;
      group.reservationLink = reservationLink + '/' + group.id;
      // RLO, make sure each group has a price, if not set it to the base price
      if ((group.price ?? 0) === 0) {
        group.price = reservationBasePrice;
      }

      if (!group.currency) {
        group.currency = reservationCurrency;
      }
      group.agreements = group.agreements || [];
      let addAgreements = [];
      reservationAgreements.forEach(agreement => {
        if (!group.agreements.some(existing => existing.id === agreement.id)) {
            addAgreements.push(agreement);
        }
      });
      group.agreements = [...addAgreements, ...group.agreements];

    });
    

  
 
  }



  static parseDescription(blocks) {
    if (!blocks || blocks.length === 0)
      return [];

    const description = [];
    let currentHeader = null;

    blocks.forEach((block) => {
      if (block.type === "header") {
        currentHeader = {
          title: `<h${block.data.level}>${block.data.text}</h${block.data.level}>`,
          content: "",
        };
        description.push(currentHeader);
      } else if (block.type === "paragraph") {
        if (!currentHeader) {
          currentHeader = { title: "", content: "" };
          description.push(currentHeader);
        }
        currentHeader.content += `<p>${block.data.text}</p>`;
      } else if (block.type === "list" && currentHeader) {
        currentHeader.content += "<ul>";
        block.data.items.forEach((item) => {
          currentHeader.content += `<li>${item}</li>`;
        });
        currentHeader.content += "</ul>";
      } else if (block.type === "nestedlist" && currentHeader) {
        if (block.data.style === "ordered") {
          currentHeader.content += `<ol>${block.data.items.map(item => `<li>${item.content}${item.items && item.items.length ? `<ol>${item.items.map(subItem => `<li>${subItem.content}</li>`).join('')}</ol>` : ''}</li>`).join('')}</ol>`;
        } else {
          currentHeader.content += `<ul>${block.data.items.map(item => `<li>${item.content}${item.items && item.items.length ? `<ul>${item.items.map(subItem => `<li>${subItem.content}</li>`).join('')}</ul>` : ''}</li>`).join('')}</ul>`;
        }
      }
    });

    return description;
  }

  static async fetchBySlug(slug) {
    try {
      let data = await rpAPI.getOfferBySlug(slug);
      if (!data && !isNaN(slug)) {
        const groupMeta = await rpAPI.getGroupSlug(slug);
        if (groupMeta?.slug) {
          data = await rpAPI.getOfferBySlug(groupMeta.slug);
        }
      }
      if (!data) {
        return false;
      }
      return new GroupReservation(data);
    } catch (error) {
      console.error('Error fetching GroupReservation data:', error);
      throw error;
    }
  }

  static async fetchById(id) {
    try {
      const data = await rpAPI.getOfferById(id);
      if (!data) {
        throw new Error("No published ReservationOffer found");
      }
      return new GroupReservation(data);
    } catch (error) {
      console.error('Error fetching ReservationOffer data:', error);
      throw error;
    }
  }

  static async fetchAllGroups() {
    try {
      const response = await rpAPI.getAllGroups();
      if (!response || response.length === 0) {
        throw new Error("No published ReservationOffer found");
      }
      let allGroups = [];
      response.map(reservationData => {
        const reservation = new GroupReservation(reservationData);
        if (reservation.groups) {
          reservation.groups.sort((a, b) => {
            return (a.sort || 0) - (b.sort || 0);
          });
          allGroups.push(...reservation.groups);
        }
      });

      return allGroups;
    } catch (error) {
      console.error('Error fetching ReservationOffer data:', error);
      throw error;
    }
  }
}